export default {
    date: 'Date',
    weight: 'Weight',
    childGender: 'Gender',
    finding: 'Finding',
    commentAndComplications: 'Comment And Complications ',
    parityTypeId: 'Parity Type',
}